import { sanitizeInput } from "./sanitize";

export const UTM_PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

/**
 * Lê os parâmetros UTM da query string.
 * Retorna apenas as chaves com valor válido; ausentes ou vazias são omitidas.
 */
const getUtmParams = (
  search = typeof window === "undefined" ? "" : window.location.search,
) => {
  const params = new URLSearchParams(search);

  return UTM_PARAM_KEYS.reduce((utmParams, key) => {
    const value = sanitizeInput(params.get(key)).trim();
    if (value) utmParams[key] = value;
    return utmParams;
  }, {});
};

export default getUtmParams;
